import { useInfiniteQuery } from 'react-query';
import api from 'src/services/api';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_PACKAGED_APP_DEVICE_IMPACTED_DEVICES_KEY } from 'src/constants/query';
import { objectToQueryString } from 'src/utils/uri';

const getPackagedAppImpactedDevices = ({
  customerEnvId,
  packagedAppId,
  page,
  limit,
  query = {},
  signal,
}) =>
  api.get(
    `/packagedApp/${customerEnvId}/${packagedAppId}/affectedDevices?${objectToQueryString(query)}`,
    {
      params: {
        Page: page,
        Limit: limit,
      },
      ...(signal ? { signal } : {}),
    },
  );

export const useInfinitePackagedAppImpactedDevices = ({
  packagedAppId,
  apiQuery,
  limit = 50,
  enabled = true,
}) => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  return useInfiniteQuery(
    [WDAC_PACKAGED_APP_DEVICE_IMPACTED_DEVICES_KEY, customerEnvId, packagedAppId, apiQuery, limit],
    ({ pageParam = 1, signal }) =>
      getPackagedAppImpactedDevices({
        customerEnvId,
        packagedAppId,
        page: pageParam,
        limit,
        query: apiQuery,
        signal,
      }),
    {
      enabled: enabled && !!customerEnvId && !!packagedAppId,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, pages) => {
        const loaded = pages.reduce((acc, page) => acc + (page.affectedDevices?.length || 0), 0);
        return loaded < (lastPage.totalCount || 0) ? pages.length + 1 : undefined;
      },
    },
  );
};
